import cn from "classnames";
import ReactCalendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import styles from "./Calendar.module.scss";
import { ICalendarProps } from "./Calendar.props";
import { useCalendarControl } from "./useCalendarControl";
import { isEmptyPeriods } from "../Periods.utils";
import { useIntl } from "react-intl";

function lightenColor(color: string, percent: number) {
  const num = parseInt(color.slice(1), 16);
  const R = (num >> 16) & 0xff;
  const G = (num >> 8) & 0xff;
  const B = num & 0xff;
  const amt = Math.round(2.55 * percent);
  const newR = Math.min(R + amt, 255);
  const newG = Math.min(G + amt, 255);
  const newB = Math.min(B + amt, 255);
  return `#${((newR << 16) | (newG << 8) | newB)
    .toString(16)
    .padStart(6, "0")}`;
}

function hexToRGBA(color: string, alpha: number) {
  const hex = color.slice(1);
  let r, g, b;

  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
  } else {
    throw new Error("Некорректный формат HEX-цвета");
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// const baseColor = "#0077ff";
// // const darkerColor = lightenColor(baseColor, 60);

// const stripeStyle = {
//   background: `repeating-linear-gradient(
//       45deg,
//       ${baseColor},
//       ${baseColor} 10px,
//       ${hexToRGBA(baseColor, 0.3)} 10px,
//       ${hexToRGBA(baseColor, 0.3)} 20px
//   )`,
//   width: "100%",
//   height: "100%",
// };
function getCrossedDayStyle(color: string) {
  //const colorOnCalendar = hexToRGBA(color, 0.4);
  return {
    background: `repeating-linear-gradient(
      45deg,
      ${hexToRGBA(color, 0.4)},
      ${hexToRGBA(color, 0.4)} 10px,
      ${hexToRGBA(color, 0.1)} 10px,
      ${hexToRGBA(color, 0.1)} 20px
  )`,
    width: "100%",
    height: "100%",
  };
}

export default function Calendar(props: ICalendarProps) {

  const control = useCalendarControl(props);
  const { formatMessage } = useIntl();

  return (
    <div
      className={cn(styles.calendar_wrapper, {
        [styles.readOnly]: props.readOnly,
      })}
    >
      <div className={styles.calendar}>
        <ReactCalendar

          className={styles.calendar__panel}
          tileContent={({ date }) => {
            const plan = control.getPlanDayForDate(date);
            if (plan && !isEmptyPeriods(plan.range)) {
              return (
                <div
                  className={styles.cell_active_now}
                  title={plan.color}
                  style={
                    plan.color
                      ? {
                        background: plan.color,
                        opacity: 0.6,
                      }
                      : {
                        borderColor: "red",
                      }
                  }
                >
                  {plan.range.some(r => r.active)
                    ? ""
                    : (plan.range.length > 0 && <span>{formatMessage({ id: "manage.planinfo.ranges_off" })}</span>)
                  }
                </div>
              );

            }
          }}
          tileClassName={({ date }) => {
            let resultClasses = "";
            if (control.isSelected(date)) {
              resultClasses = styles.cell_active;
            }
            if (control.isEdited(date)) {
              resultClasses += " " + styles.edited;
            }
            return resultClasses;
          }}
          //defaultValue={moment.tz().utcOffset(0).toDate()}
          onChange={
            props.onSelectSingleDate
              ? props.onSelectSingleDate
              : control.onSelectDate
          }
          activeStartDate={control.today}
          onActiveStartDateChange={({ value, activeStartDate, action }) => {
            if (action === "next") {
              if (activeStartDate !== null) control.setToday(activeStartDate);
            }
            if (action === "prev") {
              if (activeStartDate !== null) control.setToday(activeStartDate);
            }
          }}
        />
      </div>
    </div>
  );
}
